"use client";

import { useEffect, useMemo, useState } from "react";
import { Smartphone, X } from "lucide-react";

const STORAGE_KEY = "sortkaro_app_promo_seen_v1";

export default function AppPromoPopup() {
  const [visible, setVisible] = useState(false);

  const userContext = useMemo(() => {
    if (typeof window === "undefined") {
      return {
        platform: "android",
        ctaLabel: "Get Android App",
        ctaUrl: "https://play.google.com/store/apps/details?id=com.sortkaro.user&hl=en_IN",
      };
    }

    const ua = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isMacOS = /macintosh|mac os x/.test(ua) && !isIOS;
    const isAndroid = /android/.test(ua);
    const isWindows = /windows nt/.test(ua);

    if (isIOS || isMacOS) {
      return {
        platform: "ios",
        ctaLabel: "Get iOS App",
        ctaUrl: "https://apps.apple.com/in/app/sortkaro/id6747939950",
      };
    }

    if (isAndroid || isWindows) {
      return {
        platform: "android",
        ctaLabel: "Get Android App",
        ctaUrl: "https://play.google.com/store/apps/details?id=com.sortkaro.user&hl=en_IN",
      };
    }

    return {
      platform: "android",
      ctaLabel: "Get Android App",
      ctaUrl: "https://play.google.com/store/apps/details?id=com.sortkaro.user&hl=en_IN",
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Show only on website start (homepage), once per browser tab session.
    const isHomePage = window.location.pathname === "/";
    if (!isHomePage) return;

    const alreadySeenInSession = sessionStorage.getItem(STORAGE_KEY) === "1";
    if (alreadySeenInSession) return;

    const timer = setTimeout(() => {
      setVisible(true);
      sessionStorage.setItem(STORAGE_KEY, "1");
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  const title = "Try the app for better discounts";
  const subtitle = userContext.platform === "ios"
    ? "We detected Apple device. Get smoother booking and better offers in iOS app."
    : "We detected Android/Windows device. Get smoother booking and better offers in Android app.";

  return (
    <div className="fixed inset-0 z-[9999] flex items-end justify-center bg-black/35 backdrop-blur-[1px] p-4 pb-[calc(env(safe-area-inset-bottom)+1rem)]">
      <div className="w-[min(380px,calc(100vw-2rem))] rounded-2xl border border-[#dbe7fb] bg-white/95 backdrop-blur-md shadow-[0_18px_45px_rgba(2,25,72,0.24)]">
      <div className="p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#e9f1ff] text-[#0b5fb7] flex items-center justify-center flex-shrink-0">
            <Smartphone className="w-5 h-5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[16px] font-semibold text-gray-900 leading-5">{title}</p>
            <p className="text-[13px] text-gray-600 mt-1 leading-relaxed">{subtitle}</p>
          </div>
          <button
            onClick={closePopup}
            aria-label="Close app promo"
            className="w-7 h-7 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-500"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="mt-3 space-y-2">
          <a
            href={userContext.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full h-10 rounded-xl bg-[#0b5fb7] text-white text-[13px] font-semibold flex items-center justify-center hover:bg-[#0a4f99] transition-colors"
          >
            {userContext.ctaLabel}
          </a>
         
        </div>
      </div>
      </div>
    </div>
  );
}
